const CART_ID_KEY = 'loop-coffee.cart_id';

export const cartStorage = {
    get() {
        try {
            return window.localStorage.getItem(CART_ID_KEY);
        } catch {
            return null;
        }
    },
    set(cartId) {
        try {
            window.localStorage.setItem(CART_ID_KEY, cartId);
        } catch {
            // Private mode: the cart still works for this page view.
        }
    },
    clear() {
        try {
            window.localStorage.removeItem(CART_ID_KEY);
        } catch {
            // ignore
        }
    },
};
